module.exports = "Links lead to another part of an app, other pages, or help articles. They can also be used to initiate commands.\n"